import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    CardActions, RadioGroup,
    Grid, TableHead,
    FormControl,
    FormLabel, Paper,
    FormControlLabel,
    Radio, InputLabel, Select, MenuItem,
    TextField, Typography,
    Box, Divider, Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from "@mui/material";
import CustomButton from "../../../components/buttons/customButton";
import SingleSelect from "../../../components/Selections/singleSelect";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import MultiSelectWithAll from "../../../components/Selections/multiSelectWithAll";
import DeleteIcon from '@mui/icons-material/Delete';
import { useData } from '../../../context/DataContext';
import cottonData from '../Cotton.json'
import { useLocation, useNavigate } from "react-router-dom";
import { updateFieldBook } from "../../../context/createAPI";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getClientTheme } from "../../../theme/clientTheme";

const FieldBookEdit = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { rowData } = location.state || {};
    const ratioOptions = Array.from({ length: 10 }, (_, i) => ({ value: i + 1, label: `1:${i + 1}`, }));
    const { years = [], farmers = [], user = [], getFieldBooks = [], handleFieldBooks, villageGroups, user_client_id } = useData();
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const clientTheme = getClientTheme(user_client_id);
    const defaultWorkNames = ["Gap Filling", "Weeding", "Herbicide"];

    const getDefaultRows7th = () =>
        Array.from({ length: defaultWorkNames.length }, (_, i) => ({
            id: (i + 1).toString(),
            workDetails: defaultWorkNames[i],
            name: "", // ✅ one name per row
            quantity: '',
            noOfLabours: '',
            labourCost: "",
            totalLabourChargesInGapFilling: '',
            total_cost: '',
            estatus: 1,
        }));

    const { year, village_name, group_name, farmer_name } = rowData || {};
    const [state, setState] = useState({
        land_details_arr: [{ soil_type: "", soil_test: "", total_land: "", BCI_land: "" }],
        landDetailsError: "",
        water_manage_arr: [{ irrigation_facility: "", source_irrigation: "", irrigating_hr: "", irrigation_cm: "", labour_cost: "", fuel_cost: "", ele_cost: "", total_cost: "" }],
        crop_details_arr: [{ inter_crop: "", ratio_inter_crop: "", seed_cost: "", labour_cost: "", other_cost: "", total_cost: "" }],
        form_option_5th_rows: [{ id: "1", type_work: "", equpment_cost: "", fuel_ltrs: "", fuel_cost: "", labour_cost: "", total_cost: "", estatus: 1, grandTotal: "" }],
        form_option_6th_rows: [{ id: "1", types: '', variety: "", noOfpackets: '', seedPrice: '', totalSeedCost: '', labourCost: '', total_cost: '', estatus: 1 }],
        form_option_7th_rows: getDefaultRows7th(),
        form_option_8th_rows: [{ id: "1", typeOf: '', quantity: '', fertilizerCost: '', labourCost: '', totalLabourChargesInOrganicInfo: "", total_cost: '', estatus: 1 }],
        form_option_9th_rows: [{ id: "1", pesticide_name: '', quantity: '', costOfPesticide: '', labourCost: '', total_cost: '', estatus: 1 }],
        form_option_10th_rows: [{ id: "1", practices: '', quantity: '', cost: '', total_cost: '', estatus: 1 }],
        form_option_11th_rows: [{ id: "1", labour_count: '', labour_rate: '', totalLabourChargesInCottonHarvestingInfo: "", yield: '', cotton_colour_bags: '', greeding_segrigation: '', total_cost: '', estatus: 1 }],
        form_option_12th_rows: [{ id: "1", date: '', sold_cotton: '', ginner: '', cotton_quantity: '', rate: '', income_cotton: '', transport_cost: '', other_cost: '', estatus: 1, total_cost: '' }],
        form_option_13th_rows: [{ usingHHP: '', HHP_name: '', HHP_quantity: '', usingCocktails: '', cocktailsName: '', cock_quantity: '', hhp_cost: "", cocktailsCost: "", total_cost: "", awareness_PAN_Group: "" }],
        form_option_14th_rows: [{ preparation_fuel_liters: '', preparation_fuel_cost: '', total_preparation_fuel_cost: '', transportation_fuel_liters: '', transportation_fuel_cost: '', total_transportation_fuel_cost: '', operations_fuel_liters: '', operations_fuel_cost: '', total_operations_fuel_cost: '', overallLiters: '', finalCost: '', estatus: 1 }],
        safety_precautions_arr: [],
        cotton_income_details_arr: [
            { id: 'A', label: 'Income from Cotton', value: '', is_disabled: true },
            { id: 'B', label: 'OTHER INCOME', value: '', is_disabled: true },
            { id: 'C', label: 'TOTAL INCOME (A+B)', value: '', is_disabled: true },
            { id: 'D', label: 'TOTAL EXPENDETURE', value: '', is_disabled: true },
            { id: 'E', label: 'NET PROFIT (C - D)', value: '', is_disabled: true }
        ],
        awareness_childlabour_details_arr: [
            { id: 1, name: 'Labour Rights', value: '', },
            { id: 2, name: 'Eradication of Child Labour', value: '' },
            { id: 3, name: 'Minimum Wages', value: '' },
            { id: 4, name: 'Eradication of Gender Discrimination and sexual Harassment', value: '' },
            { id: 5, name: 'Equal Pay for equal Work', value: '' },
            { id: 6, name: 'Providing Minimum Facilities to labours', value: '' },
            { id: 7, name: 'Occupation Safety and Health Care', value: '' },
            { id: 8, name: 'Eradication of Forced labour and Compulsory Labour', value: '' },
            { id: 9, name: 'Formation of Gender committee', value: '' },
        ],
        is_loading: false,
        filterFarmers: []
    });


    useEffect(() => {
        if (rowData) {
            setState((prevState) => {
                return {
                    ...prevState,
                    land_details_arr: rowData.land_details.map((item) => ({
                        BCI_land: item.BCI_land || "",
                        soil_type: item.soil_type || "",
                        soil_test: item.soil_test || false,
                        total_land: item.total_land || "",
                    })),
                    water_manage_arr: rowData.water_source.map((item) => ({
                        irrigation_facility: item.irrigation_facility,
                        source_irrigation: item.source_irrigation,
                        irrigating_hr: item.irrigating_hr,
                        irrigation_cm: item.irrigation_cm,
                        labour_cost: item.labour_cost,
                        fuel_cost: item.fuel_cost,
                        ele_cost: item.ele_cost,
                        total_cost: item.total_cost,
                    })),

                    crop_details_arr: rowData.intercrop.map((item) => ({
                        inter_crop: item.inter_crop,
                        ratio_inter_crop: item.ratio_inter_crop,
                        seed_cost: item.seed_cost,
                        labour_cost: item.labour_cost,
                        other_cost: item.other_cost,
                        total_cost: item.total_cost,
                    })),

                    form_option_5th_rows: rowData.land_preparation.map((item) => ({
                        id: item.id,
                        type_work: item.type_work,
                        equpment_cost: item.equpment_cost,
                        fuel_ltrs: item.fuel_ltrs,
                        fuel_cost: item.fuel_cost,
                        labour_cost: item.labour_cost,
                        total_cost: item.total_cost,
                        estatus: item.estatus,
                    })),

                    form_option_6th_rows: rowData.cotton_crop_details.map((item) => ({
                        id: item.id,
                        types: item.types,
                        variety: item.variety,
                        noOfpackets: item.noOfpackets,
                        seedPrice: item.seedPrice,
                        labourCost: item.labourCost,
                        total_cost: item.total_cost,
                        estatus: item.estatus,
                        totalSeedCost: item.totalSeedCost,
                    })),

                    form_option_7th_rows: rowData.weeds.map((item) => ({
                        id: item.id,
                        workDetails: item.workDetails,
                        name: item.name,
                        quantity: item.quantity,
                        noOfLabours: item.noOfLabours,
                        total_cost: item.total_cost,
                        estatus: item.estatus,
                        labourCost: item.labourCost,
                        totalLabourChargesInGapFilling: item.totalLabourChargesInGapFilling,
                    })),

                    form_option_8th_rows: rowData.organic_fertilizers.map((item) => ({
                        id: item.id,
                        typeOf: item.typeOf,
                        quantity: item.quantity,
                        fertilizerCost: item.fertilizerCost,
                        labourCost: item.labourCost,
                        total_cost: item.total_cost,
                        totalLabourChargesInOrganicInfo: item.totalLabourChargesInOrganicInfo,
                        estatus: item.estatus,
                    })),

                    form_option_13th_rows: rowData.hhp_coktails.map((item) => ({
                        usingHHP: item.usingHHP,
                        HHP_name: item.HHP_name,
                        HHP_quantity: item.HHP_quantity,
                        usingCocktails: item.usingCocktails,
                        cocktailsName: item.cocktailsName,
                        cock_quantity: item.cock_quantity,
                        awareness_PAN_Group: item.awareness_PAN_Group,
                        hhp_cost: item.hhp_cost, cocktailsCost: item.cocktailsCost, total_cost: item.total_cost,
                    })),

                    form_option_9th_rows: rowData.pesticides_info.map((item) => ({
                        id: item.id,
                        pesticide_name: item.pesticide_name,
                        quantity: item.quantity,
                        costOfPesticide: item.costOfPesticide,
                        labourCost: item.labourCost,
                        total_cost: item.total_cost,
                        estatus: item.estatus,
                    })),

                    form_option_10th_rows: rowData.best_ownership_practices.map((item) => ({
                        id: item.id,
                        practices: item.practices,
                        quantity: item.quantity,
                        cost: item.cost,
                        estatus: item.estatus,
                        total_cost: item.total_cost
                    })),

                    safety_precautions_arr: rowData.safety_precautions,

                    form_option_11th_rows: rowData.cotton_picking.map((item) => ({
                        id: item.id,
                        labour_count: item.labour_count,
                        labour_rate: item.labour_rate,
                        yield: item.yield,
                        cotton_colour_bags: item.cotton_colour_bags,
                        greeding_segrigation: item.greeding_segrigation,
                        total_cost: item.total_cost,
                        totalLabourChargesInCottonHarvestingInfo: item.totalLabourChargesInCottonHarvestingInfo,
                        estatus: item.estatus,
                    })),

                    form_option_12th_rows: rowData.cotton_sales.map((item) => ({
                        id: item.id,
                        date: item.date,
                        sold_cotton: item.sold_cotton,
                        ginner: item.ginner,
                        cotton_quantity: item.cotton_quantity,
                        rate: item.rate,
                        income_cotton: item.income_cotton,
                        transport_cost: item.transport_cost,
                        other_cost: item.other_cost,
                        total_cost: item.total_cost,
                        estatus: item.estatus,
                    })),

                    form_option_14th_rows: rowData.fuel_costs.map((item) => ({
                        preparation_fuel_liters: item.preparation_fuel_liters,
                        preparation_fuel_cost: item.preparation_fuel_cost,
                        total_preparation_fuel_cost: item.total_preparation_fuel_cost,
                        transportation_fuel_liters: item.transportation_fuel_liters,
                        transportation_fuel_cost: item.transportation_fuel_cost,
                        total_transportation_fuel_cost: item.total_transportation_fuel_cost,
                        operations_fuel_liters: item.operations_fuel_liters,
                        operations_fuel_cost: item.operations_fuel_cost,
                        total_operations_fuel_cost: item.total_operations_fuel_cost,
                        overallLiters: item.overallLiters,
                        finalCost: item.finalCost,
                        estatus: item.estatus
                    })),

                    cotton_income_details_arr: rowData.cotton_income.length > 0
                        ? (rowData.cotton_income).map((item) => ({
                            id: item.id || '',
                            label: item.label || '',
                            value: item.value || '',
                            is_disabled: item.is_disabled || ''
                        }))
                        : [
                            { id: 'A', label: 'Income from Cotton', value: '', is_disabled: true },
                            { id: 'B', label: 'OTHER INCOME', value: '', is_disabled: true },
                            { id: 'C', label: 'TOTAL INCOME (A+B)', value: '', is_disabled: true },
                            { id: 'D', label: 'TOTAL EXPENDITURE', value: '', is_disabled: true },
                            { id: 'E', label: 'NET PROFIT (C - D)', value: '', is_disabled: true },
                        ],
                    awareness_childlabour_details_arr: rowData.awareness_childlabour.length > 0
                        ? (rowData.awareness_childlabour).map((item) => ({
                            id: item.id || '',
                            name: item.name || '',
                            value: item.value || '',
                        }))
                        : [
                            { id: 1, name: 'Labour Rights', value: '' },
                            { id: 2, name: 'Eradication of Child Labour', value: '' },
                            { id: 3, name: 'Minimum Wages', value: '' },
                            { id: 4, name: 'Eradication of Gender Discrimination and sexual Harassment', value: '' },
                            { id: 5, name: 'Equal Pay for equal Work', value: '' },
                            { id: 6, name: 'Providing Minimum Facilities to labours', value: '' },
                            { id: 7, name: 'Occupation Safety and Health Care', value: '' },
                            { id: 8, name: 'Eradication of Forced labour and Compulsory Labour', value: '' },
                            { id: 9, name: 'Formation of Gender committee', value: '' },
                        ],
                }
            });
        }
    }, [rowData]);



    useEffect(() => {
        if (!state.form_option_12th_rows.length) return;

        setState(prevState => {
            const totalOtherCost = prevState.form_option_12th_rows.reduce(
                (sum, row) => sum + (parseFloat(row.other_cost) || 0),
                0
            );

            const finalArray = prevState.cotton_income_details_arr.map(item =>
                item.id === 'B'
                    ? { ...item, value: totalOtherCost }
                    : item
            );

            return {
                ...prevState,
                cotton_income_details_arr: finalArray,
            };
        });
    }, [state.form_option_12th_rows]);


    const handleLandChange = (name, value) => {
        // const { name, value } = e.target;

        if (name === "total_land" || name === "BCI_land") {
            let formattedValue = value.replace(/\D/g, "").slice(0, 50);

            if (value.includes(".")) {
                const [integerPart, decimalPart] = value.split(".");
                formattedValue = `${integerPart}.${decimalPart.slice(0, 2)}`;
            }

            setState((prevState) => ({
                ...prevState,
                land_details_arr: prevState.land_details_arr.map((item, i) =>
                    i === 0 ? { ...item, [name]: formattedValue } : item
                ),
                landDetailsError: "",
            }));
        }
        else if (name === "soil_type") {
            const selectedSoilType = cottonData.getSoilType.find(
                (option) => option.value === parseInt(value)
            );

            setState((prevState) => ({
                ...prevState,
                land_details_arr: prevState.land_details_arr.map((item, i) =>
                    i === 0
                        ? { ...item, soil_type: selectedSoilType ? selectedSoilType.label : "" }
                        : item
                ),
                landDetailsError: "",
            }));
        } else if (name === "soil_test") {
            setState((prevState) => ({
                ...prevState,
                land_details_arr: prevState.land_details_arr.map((item, i) =>
                    i === 0 ? { ...item, soil_test: value === "Yes" } : item
                ),
                landDetailsError: "",
            }));
        }
    };

    const handleWaterChange = (name, value) => {


        const formatToTwoDecimals = (val) => {
            if (val.includes(".")) {
                const [integerPart, decimalPart] = val?.split(".");
                return decimalPart?.length > 2 ? `${integerPart}.${decimalPart?.slice(0, 2)}` : val;
            }
            return val;
        };
        let cottonDataMain = cottonData;

        setState((prevState) => {

            const updatedWaterManageArr = prevState.water_manage_arr?.map((item, i) => {

                if (i === 0) {
                    let updatedItem = { ...item, [name]: formatToTwoDecimals(value) };
                    if (name === "irrigation_facility") {
                        const selectedIrrigationType = cottonDataMain?.irrigation_Facility?.find(
                            (option) => option.value === parseInt(value)
                        );

                        console.log("selectedIrrigationType", selectedIrrigationType);

                        updatedItem.irrigation_facility = selectedIrrigationType ? selectedIrrigationType.label : "";
                    }

                    if (name === "source_irrigation") {
                        const selectedSourceType = cottonDataMain?.source_irrigation?.find(
                            (option) => option.value === parseInt(value)
                        );
                        updatedItem.source_irrigation = selectedSourceType ? selectedSourceType.label : "";
                    }

                    if (["labour_cost", "fuel_cost", "ele_cost"].includes(name)) {
                        const labourCost = parseFloat(updatedItem?.labour_cost || 0);
                        const fuelCost = parseFloat(updatedItem?.fuel_cost || 0);
                        const eleCost = parseFloat(updatedItem?.ele_cost || 0);
                        updatedItem.total_cost = (labourCost + fuelCost + eleCost).toFixed(2);
                    }
                    return updatedItem;
                }
                return item;
            });

            return {
                ...prevState,
                water_manage_arr: updatedWaterManageArr,
            };
        });
    };

    // const handleCropChange = (name, value) => {

    //     const formatToTwoDecimals = (val) => {
    //         if (val.includes(".")) {
    //             const [integerPart, decimalPart] = val.split(".");
    //             return decimalPart?.length > 2 ? `${integerPart}.${decimalPart.slice(0, 2)}` : val;
    //         }
    //         return val;
    //     };

    //     setState((prevState) => {
    //         if (!Array.isArray(prevState.crop_details_arr)) {
    //             console.error("crop_details_arr is not an array.");
    //             return prevState;
    //         }

    //         const updatedCropDetailsArr = prevState.crop_details_arr?.map((item, i) => {
    //             if (i === 0) {
    //                 let updatedItem = { ...item };

    //                 if (name === "inter_crop") {
    //                     const selectedCrop = cottonData.inter_crop?.find(
    //                         (option) => option.value === parseInt(value, 10)
    //                     );
    //                     updatedItem.inter_crop = selectedCrop ? selectedCrop.label : "";
    //                 } else if (["seed_cost", "labour_cost", "other_cost"].includes(name)) {
    //                     updatedItem[name] = formatToTwoDecimals(value || "0");

    //                     const seedCost = parseFloat(updatedItem.seed_cost || 0);
    //                     const labourCost = parseFloat(updatedItem.labour_cost || 0);
    //                     const otherCost = parseFloat(updatedItem.other_cost || 0);
    //                     updatedItem.total_cost = (seedCost + labourCost + otherCost).toFixed(2);
    //                 } else if (name === "ratio_inter_crop") {
    //                     updatedItem[name] = formatToTwoDecimals(value || "0");
    //                 }

    //                 return updatedItem;
    //             }
    //             return item;
    //         });

    //         return {
    //             ...prevState,
    //             crop_details_arr: updatedCropDetailsArr,
    //         };
    //     });

    // };

    const handleCropChange = (name, value) => {

        const formatToTwoDecimals = (val) => {
            if (val.includes(".")) {
                const [integerPart, decimalPart] = val.split(".");
                return decimalPart?.length > 2 ? `${integerPart}.${decimalPart.slice(0, 2)}` : val;
            }
            return val;
        };

        setState((prevState) => {
            if (!Array.isArray(prevState.crop_details_arr)) {
                console.error("crop_details_arr is not an array.");
                return prevState;
            }

            const updatedCropDetailsArr = prevState.crop_details_arr?.map((item, i) => {
                if (i === 0) {
                    let updatedItem = { ...item };

                    if (name === "inter_crop") {
                        const selectedCrop = cottonData.inter_crop?.find(
                            (option) => option.value === parseInt(value, 10)
                        );
                        updatedItem.inter_crop = selectedCrop ? selectedCrop.label : "";
                    } else if (["seed_cost", "labour_cost", "other_cost"].includes(name)) {
                        updatedItem[name] = formatToTwoDecimals(value || "0");

                        const seedCost = parseFloat(updatedItem.seed_cost || 0);
                        const labourCost = parseFloat(updatedItem.labour_cost || 0);
                        const otherCost = parseFloat(updatedItem.other_cost || 0);
                        updatedItem.total_cost = (seedCost + labourCost + otherCost).toFixed(2);
                    }
                    else if (name === "ratio_inter_crop") {
                        // updatedItem[name] = formatToTwoDecimals(value || "0");
                        const selectedCrop = ratioOptions?.find(
                            (option) => option.value === parseInt(value, 10)
                        );
                        updatedItem.ratio_inter_crop = selectedCrop ? selectedCrop.label : "";
                    }
                    return updatedItem;
                }
                return item;
            });

            return {
                ...prevState,
                crop_details_arr: updatedCropDetailsArr,
            };
        });

    };

    const handleAddRowFormChange = (index, name, arrayType, value, checked) => {

        const formatToTwoDecimals = (val) => {
            if (!isNaN(val) && val.includes(".")) {
                const [integerPart, decimalPart] = val.split(".");
                return `${integerPart}.${decimalPart.slice(0, 2)}`;
            }
            return val;
        };

        setState(prevState => {
            const updatedState = { ...prevState };

            if (arrayType === "5th") {
                updatedState.form_option_5th_rows = prevState.form_option_5th_rows.map((row, idx) => {
                    if (idx === index) {
                        const updatedRow = { ...row, estatus: 1, [name]: formatToTwoDecimals(value) };

                        const equpmentCost = parseFloat(updatedRow.equpment_cost || 0);
                        // const fuelCost = parseFloat(updatedRow.fuel_cost || 0);
                        const labourCost = parseFloat(updatedRow.labour_cost || 0);
                        updatedRow.total_cost = (equpmentCost + labourCost).toFixed(2);

                        return updatedRow;
                    }
                    return row;
                });
            } else if (arrayType === '6th') {
                updatedState.form_option_6th_rows = prevState.form_option_6th_rows.map((row, idx) => {

                    if (idx === index) {
                        if (name === "types") {
                            const selectedType = cottonData.seedsType.find(
                                (option) => option.value === parseInt(value)
                            );
                            return { ...row, estatus: 1, types: selectedType ? selectedType.label : "" };
                        }

                        const updatedRow = { ...row, estatus: 1, [name]: formatToTwoDecimals(value) };

                        if (name === "seedPrice" || name === "labourCost" || name === "noOfpackets") {
                            const seedPrice = parseFloat(updatedRow.seedPrice || 0);
                            const noOfPackets = parseInt(updatedRow.noOfpackets || 0); // Ensure updated value is used

                            let totalSeedsData = noOfPackets * seedPrice; // Keep it as a number

                            updatedRow.totalSeedCost = totalSeedsData.toFixed(2); // Format when assigning
                            const labourCost = parseFloat(updatedRow.labourCost || 0);
                            updatedRow.total_cost = (totalSeedsData + labourCost).toFixed(2); // Ensure numeric addition
                        }

                        return updatedRow;
                    }
                    return row;
                });
            } else if (arrayType === '7th') {
                // updatedState.form_option_7th_rows = prevState.form_option_7th_rows.map((row, idx) =>
                //   idx === index ? { ...row, estatus: 1, [name]: formatToTwoDecimals(value) } : row
                // );

                // { id: nextId.toString(), workDetails: '', name: '', quantity: '', noOfLabours: '', totalLabourChargesInGapFilling: "", total_cost: '', estatus: 1 }
                // updatedState.form_option_7th_rows = prevState.form_option_7th_rows.map((row, idx) => {
                //   if (idx === index) {
                //     const updatedRow = {
                //       ...row,
                //       estatus: 1,
                //       [name]: isNaN(value) ? value : formatToTwoDecimals(value),
                //     };

                //     const quantity = parseFloat(updatedRow.quantity || 0);
                //     const labourCost = parseFloat(updatedRow.noOfLabours || 0);

                //     if (name === "quantity" || name === "noOfLabours") {
                //       const labourTotal = quantity * labourCost;

                //       updatedRow.totalLabourChargesInGapFilling =
                //         labourTotal.toFixed(2);

                //       updatedRow.total_cost = labourTotal.toFixed(2);
                //     }

                //     if (name === "total_cost") {
                //       updatedRow.total_cost = formatToTwoDecimals(value);
                //     }

                //     return updatedRow;
                //   }
                //   return row;
                // })


                updatedState.form_option_7th_rows = prevState.form_option_7th_rows.map(
                    (row, idx) => {
                        if (idx === index) {
                            const updatedRow = {
                                ...row,
                                estatus: 1,
                                [name]: isNaN(value) ? value : formatToTwoDecimals(value),
                            };

                            // 🔹 Only for index 0 & 1
                            if (idx !== 2) {
                                const noOfLabours = parseFloat(updatedRow.noOfLabours || 0);
                                const labourCost = parseFloat(updatedRow.labourCost || 0);

                                if (name === "noOfLabours" || name === "labourCost") {
                                    const labourTotal = noOfLabours * labourCost;

                                    updatedRow.totalLabourChargesInGapFilling =
                                        labourTotal.toFixed(2);
                                    updatedRow.total_cost = labourTotal.toFixed(2);
                                }
                            }

                            // 🔹 Index 2 → manual total
                            if (idx === 2 && name === "total_cost") {
                                updatedRow.total_cost = formatToTwoDecimals(value);
                            }

                            return updatedRow;
                        }
                        return row;
                    }
                );

            } else if (arrayType === '8th') {
                updatedState.form_option_8th_rows = prevState.form_option_8th_rows.map((row, idx) => {
                    if (idx === index) {
                        if (name === 'fertilizer') {
                            const selectedFertilizer = cottonData.Fertilizers.find(option => option.value === parseInt(value));
                            return {
                                ...row,
                                estatus: 1,
                                typeOf: selectedFertilizer ? selectedFertilizer.label : "",
                                // quantity: row.quantity
                            };
                        }
                        console.log("labourCost", name, value);

                        const updatedRow = { ...row, estatus: 1, [name]: formatToTwoDecimals(value) };
                        const fertilizer_Cost = parseFloat(updatedRow.fertilizerCost || 0);
                        const quantity = parseFloat(updatedRow.quantity || 0);

                        updatedRow.totalLabourChargesInOrganicInfo = (
                            quantity * fertilizer_Cost
                        ).toFixed(2);

                        const labourCost = parseFloat(updatedRow.labourCost || 0);
                        const totalLabourChargesInOrganicInfo = parseFloat(updatedRow.totalLabourChargesInOrganicInfo || 0);

                        updatedRow.total_cost = (
                            labourCost + totalLabourChargesInOrganicInfo
                        ).toFixed(2);

                        // if (name === 'fertilizerCost' || name === 'labourCost') {
                        //   const fertilizerCost = parseFloat(updatedRow.fertilizerCost || 0);
                        //   const labourCost = parseFloat(updatedRow.totalLabourChargesInOrganicInfo || 0);
                        //   updatedRow.total_cost = (fertilizerCost + labourCost).toFixed(2);
                        // }

                        return updatedRow;
                    }
                    return row;
                });
            } else if (arrayType === '9th') {
                updatedState.form_option_9th_rows = prevState.form_option_9th_rows.map((row, idx) => {
                    if (idx === index) {
                        if (name === 'pesticide') {
                            const selectedPesticide = cottonData.Pesticides.find(option => option.value === parseInt(value));
                            return {
                                ...row,
                                estatus: 1,
                                pesticide_name: selectedPesticide ? selectedPesticide.label : ""
                            };
                        }

                        const updatedRow = { ...row, estatus: 1, [name]: formatToTwoDecimals(value) };

                        if (name === 'costOfPesticide' || name === 'labourCost') {
                            const costOfPesticide = parseFloat(updatedRow.costOfPesticide || 0);
                            const labourCost = parseFloat(updatedRow.labourCost || 0);
                            updatedRow.total_cost = (costOfPesticide + labourCost).toFixed(2);
                        }

                        return updatedRow;
                    }
                    return row;
                });
            } else if (arrayType === '10th') {

                updatedState.form_option_10th_rows = prevState.form_option_10th_rows.map((row, idx) => {
                    if (idx === index) {
                        if (name === "practices") {
                            const selectedPractices = cottonData.Practices.find(
                                (option) => option.value === parseInt(value)
                            );
                            return { ...row, estatus: 1, practices: selectedPractices ? selectedPractices.label : "" };
                        }

                        const updatedRow = { ...row, estatus: 1, [name]: formatToTwoDecimals(value) };

                        if (name === "quantity" || name === "cost") {
                            const quantity = parseFloat(updatedRow.quantity || 0);
                            const practicesCost = parseFloat(updatedRow.cost || 0);

                            updatedRow.total_cost = (quantity * practicesCost).toFixed(2); // Numeric addition
                        }

                        return updatedRow;
                    }
                    return row;
                });

            } else if (arrayType === '11th') {
                // updatedState.form_option_11th_rows = prevState.form_option_11th_rows.map((row, idx) =>
                //   idx === index ? { ...row, estatus: 1, [name]: formatToTwoDecimals(value) } : row
                // );
                updatedState.form_option_11th_rows = prevState.form_option_11th_rows.map((row, idx) => {
                    if (idx === index) {
                        const updatedRow = {
                            ...row,
                            estatus: 1,
                            [name]: isNaN(value) ? value : formatToTwoDecimals(value),
                        };
                        const labourCount = parseFloat(updatedRow.labour_count || 0);
                        const labourRate = parseFloat(updatedRow.labour_rate || 0);

                        if (name === "labour_count" || name === "labour_rate") {
                            const labourTotal = labourCount * labourRate;

                            updatedRow.totalLabourChargesInCottonHarvestingInfo =
                                labourTotal.toFixed(2);

                            updatedRow.total_cost = labourTotal.toFixed(2);
                        }

                        if (name === "total_cost") {
                            updatedRow.total_cost = formatToTwoDecimals(value);
                        }

                        return updatedRow;
                    }
                    return row;
                })
            } else if (arrayType === '12th') {
                // updatedState.form_option_12th_rows = prevState.form_option_12th_rows.map((row, idx) => {
                //   if (idx === index) {

                //     const updatedRow = {
                //       ...row,
                //       estatus: 1,
                //       [name]: formatToTwoDecimals(value)
                //     };

                //     const cottonIncome = parseFloat(updatedRow.income_cotton) || 0;
                //     const transportFuel = parseFloat(updatedRow.other_cost) || 0;

                //     updatedRow.total_cost = cottonIncome + transportFuel
                //     return updatedRow;
                //   }
                //   return row
                // });

                updatedState.form_option_12th_rows = prevState.form_option_12th_rows.map((row, idx) => {
                    if (idx === index) {

                        const updatedRow = {
                            ...row,
                            estatus: 1,
                            [name]: formatToTwoDecimals(value),
                        };

                        const cottonQuantity = parseFloat(updatedRow.cotton_quantity) || 0;
                        const rate = parseFloat(updatedRow.rate) || 0;
                        const quantityAmount = cottonQuantity * rate;

                        updatedRow.income_cotton = quantityAmount.toFixed(2);

                        const incomeCotton = parseFloat(updatedRow.income_cotton) || 0;
                        const transportCost = parseFloat(updatedRow.transport_cost) || 0;
                        const otherIncomeCost = parseFloat(updatedRow.other_cost) || 0;

                        updatedRow.total_cost = (
                            // quantityAmount +
                            incomeCotton + otherIncomeCost +
                            transportCost
                        ).toFixed(2);

                        return updatedRow;
                    }
                    return row;
                });

            } else if (arrayType === '14th') {


                updatedState.form_option_14th_rows = prevState.form_option_14th_rows.map((row, idx) => {


                    if (idx === index) {
                        console.log("row", row.overallLiters, value);

                        const updatedRow = {
                            ...row,
                            estatus: 1,
                            [name]: formatToTwoDecimals(value)
                        };

                        console.log("name", name);

                        const prepFuel = Number(updatedRow.preparation_fuel_liters) || 0;
                        const opsFuel = Number(updatedRow.operations_fuel_liters) || 0;
                        const transportFuel = Number(updatedRow.transportation_fuel_liters) || 0;


                        const opsCost = Number(updatedRow.operations_fuel_cost) || 0;
                        const prepCost = Number(updatedRow.preparation_fuel_cost) || 0;
                        const transportCost = Number(updatedRow.transportation_fuel_cost) || 0;



                        if (["operations_fuel_liters", "preparation_fuel_liters", "transportation_fuel_liters"].includes(name)) {
                            updatedRow.overallLiters = prepFuel + opsFuel + transportFuel;
                        }

                        updatedRow.total_preparation_fuel_cost = prepFuel * prepCost;
                        updatedRow.total_transportation_fuel_cost = transportFuel * transportCost;
                        updatedRow.total_operations_fuel_cost = opsFuel * opsCost;


                        updatedRow.finalCost = updatedRow.total_preparation_fuel_cost + updatedRow.total_transportation_fuel_cost + updatedRow.total_operations_fuel_cost || 0;

                        console.log("updatedRow", updatedRow);
                        return updatedRow;
                    }
                    return row;
                });
            }
            return updatedState;
        });
    };

    const handleDelete = async (event, index, arrayType) => {
        event.preventDefault();

        setState(prevState => {
            const updatedState = { ...prevState };
            if (arrayType === '5th') {
                updatedState.form_option_5th_rows = prevState.form_option_5th_rows.filter((_, idx) => idx !== index);
            } else if (arrayType === '6th') {
                updatedState.form_option_6th_rows = prevState.form_option_6th_rows.filter((_, idx) => idx !== index);
            } else if (arrayType === '7th') {
                updatedState.form_option_7th_rows = prevState.form_option_7th_rows.filter((_, idx) => idx !== index);
            } else if (arrayType === '8th') {
                updatedState.form_option_8th_rows = prevState.form_option_8th_rows.filter((_, idx) => idx !== index);
            } else if (arrayType === '9th') {
                updatedState.form_option_9th_rows = prevState.form_option_9th_rows.filter((_, idx) => idx !== index);
            } else if (arrayType === '10th') {
                updatedState.form_option_10th_rows = prevState.form_option_10th_rows.filter((_, idx) => idx !== index);
            } else if (arrayType === '11th') {
                updatedState.form_option_11th_rows = prevState.form_option_11th_rows.filter((_, idx) => idx !== index);
            } else if (arrayType === '12th') {
                updatedState.form_option_12th_rows = prevState.form_option_12th_rows.filter((_, idx) => idx !== index);
            }

            return updatedState;
        });
    };

    const handleHhpCocktails = (e) => {
        const { name, value, type } = e.target;
        console.log("refer", name, value, type);

        const formatToTwoDecimals = (val) => {
            if (val.includes(".")) {
                const [integerPart, decimalPart] = val.split(".");
                return decimalPart?.length > 2 ? `${integerPart}.${decimalPart.slice(0, 2)}` : val;
            }
            return val;
        };

        setState((prevState) => {
            const updatedRows = [...prevState.form_option_13th_rows];

            if (name === "HHP_name") {
                const selectHHPName = cottonData.HHP_Names.find(
                    (option) => option.value === parseInt(value)
                );
                updatedRows[0].HHP_name = selectHHPName ? selectHHPName.label : "";
            } else {
                const formattedValue = name === "usingHHP" || name === "usingCocktails" || name === "awareness_PAN_Group" ? value : formatToTwoDecimals(value);

                updatedRows[0][name] = type === "radio" ? value === "Yes" : formattedValue;

                if (name === "usingHHP") {
                    updatedRows[0].HHP_name = "";
                }

                if (name === "usingCocktails") {
                    updatedRows[0].cocktailsName = "";
                }

                if (["hhp_cost", "cocktailsCost"].includes(name)) {
                    if (!/^\d*\.?\d*$/.test(value)) {
                        return prevState; // ❌ block text
                    }
                }

                const hhpCost = updatedRows[0].usingHHP
                    ? parseFloat(updatedRows[0].hhp_cost || 0)
                    : 0;

                const cocktailCost = updatedRows[0].usingCocktails
                    ? parseFloat(updatedRows[0].cocktailsCost || 0)
                    : 0;

                updatedRows[0].total_cost = (hhpCost + cocktailCost).toFixed(2);
            }

            return { ...prevState, form_option_13th_rows: updatedRows };
        });
    };

    const handleMultiSelectionChange = (selectedOptions) => {
        const updatedPrecautions = selectedOptions.map(option => ({
            value: option.value,
            label: option.label
        }));

        setState(prevState => ({
            ...prevState,
            safety_precautions_arr: updatedPrecautions
        }));
    };

    const handle15Change = (id, value) => {
        setState(prevState => {
            // 1️⃣ Update changed field
            const updatedArray = prevState.cotton_income_details_arr.map(item =>
                item.id === id ? { ...item, value } : item
            );

            // 2️⃣ Get numeric values safely
            const A = Number(updatedArray.find(i => i.id === 'A')?.value) || 0;
            const B = Number(updatedArray.find(i => i.id === 'B')?.value) || 0;
            const D = Number(updatedArray.find(i => i.id === 'D')?.value) || 0;

            // 3️⃣ Calculations
            const C = A + B;
            const E = Math.abs(C - D); // negative is VALID if expenditure > income

            // 4️⃣ Update calculated fields
            const finalArray = updatedArray.map(item => {
                if (item.id === 'C') return { ...item, value: C };
                if (item.id === 'E') return { ...item, value: E };
                return item;
            });

            return {
                ...prevState,
                cotton_income_details_arr: finalArray
            };
        });
    };

    const handleRadioChange = (id, value) => {
        setState((prevState) => ({
            ...prevState,
            awareness_childlabour_details_arr: prevState.awareness_childlabour_details_arr.map((item) =>
                item.id === id ? { ...item, value } : item
            ),
        }));
    };

    const handleUpdating = async (e) => {
        e.preventDefault();
        const invalidLandDetails = state.land_details_arr.some((detail) =>
            !detail.soil_type ||
            !detail.soil_test ||
            detail.total_land === "" ||
            detail.BCI_land === ""
        );

        if (invalidLandDetails) {
            setState((prevState) => ({
                ...prevState,
                landDetailsError: "All fields in Land Information are required.",
                is_loading: false,
            }));
            return; // stop function
        }

        // 3️⃣ All validations passed → Start Loader + Clear messages
        console.log("All validations passed. Calling API...");
        setState((prevState) => ({
            ...prevState,
            is_loading: true,
            submitMessage: "",
        }));

        try {
            const createApi = await updateFieldBook({
                id: rowData.id,
                land_details: state.land_details_arr,
                water_source: state.water_manage_arr,
                intercrop: state.crop_details_arr,
                land_preparation: state.form_option_5th_rows,
                cotton_crop_details: state.form_option_6th_rows,
                weeds: state.form_option_7th_rows,
                organic_fertilizers: state.form_option_8th_rows,
                pesticides_info: state.form_option_9th_rows,
                hhp_coktails: state.form_option_13th_rows,
                best_ownership_practices: state.form_option_10th_rows,
                safety_precautions: state.safety_precautions_arr,
                cotton_picking: state.form_option_11th_rows,
                cotton_sales: state.form_option_12th_rows,
                cotton_income: state.cotton_income_details_arr,
                awareness_childlabour: state.awareness_childlabour_details_arr,
                updated_by: user.user_id
            });

            if (createApi.statusCode === 200) {
                handleFieldBooks();
                localStorage.removeItem("field_book");

                setState((prevState) => ({
                    ...prevState,
                    is_loading: false,
                    submitMessage: "Form submitted successfully!",
                }));


                setSnackbar({
                    open: true,
                    message: "Form submitted successfully!",
                    severity: "success",
                });

                setTimeout(() => {
                    navigate(-1);
                }, 1000);
            }
        } catch (error) {
            console.error("Error submitting form:", error);

            setState((prevState) => ({
                ...prevState,
                is_loading: false,
                submitMessage: "An error occurred while processing your request.",
            }));

            setTimeout(() => {
                setState((prevState) => ({
                    ...prevState,
                    submitMessage: "",
                }));
            }, 1000);
        }

    };

    // useEffect(() => {
    //     setState(prevState => {

    //         const sumArray = (arr = []) =>
    //             arr.reduce((sum, item) => sum + Number(item.total_cost || 0), 0);

    //         const water_management_cost = Number(prevState.water_manage_arr?.[0]?.total_cost || 0);
    //         const crop_details_cost = Number(prevState.crop_details_arr?.[0]?.total_cost || 0);
    //         const form_option_14th_rows = Number(prevState.form_option_14th_rows?.[0]?.finalCost || 0);

    //         const form_option_11th_rows = sumArray(prevState.form_option_11th_rows);
    //         const form_option_5th_rows = sumArray(prevState.form_option_5th_rows);
    //         const form_option_6th_rows = sumArray(prevState.form_option_6th_rows);
    //         const form_option_7th_rows = sumArray(prevState.form_option_7th_rows);
    //         const form_option_8th_rows = sumArray(prevState.form_option_8th_rows);
    //         const form_option_9th_rows = sumArray(prevState.form_option_9th_rows);
    //         const form_option_10th_rows = sumArray(prevState.form_option_10th_rows);
    //         const form_option_12th_rows = sumArray(prevState.form_option_12th_rows);

    //         // 🔹 D calculation
    //         const D =
    //             water_management_cost +
    //             crop_details_cost +
    //             form_option_11th_rows +
    //             form_option_5th_rows +
    //             form_option_6th_rows +
    //             form_option_7th_rows +
    //             form_option_8th_rows +
    //             form_option_9th_rows +
    //             form_option_10th_rows +
    //             form_option_14th_rows;

    //         // 🔹 Get current B
    //         const B = Number(
    //             prevState.cotton_income_details_arr.find(i => i.id === "B")?.value || 0
    //         );

    //         // 🔹 A, C, E
    //         const A = form_option_12th_rows;
    //         const C = A + B;
    //         const E = Math.abs(C - D);
    //         // negative allowed

    //         // 🔹 Get existing values
    //         const getVal = id =>
    //             Number(prevState.cotton_income_details_arr.find(i => i.id === id)?.value || 0);

    //         // 🔹 Prevent unnecessary rerender
    //         if (
    //             getVal("A") === A &&
    //             getVal("C") === C &&
    //             getVal("D") === D &&
    //             getVal("E") === E
    //         ) {
    //             return prevState;
    //         }

    //         return {
    //             ...prevState,
    //             cotton_income_details_arr: prevState.cotton_income_details_arr.map(item => {
    //                 if (item.id === "A") return { ...item, value: A };
    //                 if (item.id === "C") return { ...item, value: C };
    //                 if (item.id === "D") return { ...item, value: D };
    //                 if (item.id === "E") return { ...item, value: E };
    //                 return item;
    //             })
    //         };
    //     });
    // }, [
    //     state.water_manage_arr,
    //     state.crop_details_arr,
    //     state.form_option_11th_rows,
    //     state.form_option_5th_rows,
    //     state.form_option_6th_rows,
    //     state.form_option_7th_rows,
    //     state.form_option_8th_rows,
    //     state.form_option_9th_rows,
    //     state.form_option_10th_rows,
    //     state.form_option_12th_rows,
    //     state.form_option_14th_rows
    // ]);


    useEffect(() => {
        setState(prevState => {

            const sumArray = (arr = []) =>
                arr.reduce((sum, item) => sum + Number(item.total_cost || 0), 0);

            const water_management_cost = Number(prevState.water_manage_arr?.[0]?.total_cost || 0);
            const crop_details_cost = Number(prevState.crop_details_arr?.[0]?.total_cost || 0);
            const form_option_14th_rows = Number(prevState.form_option_14th_rows?.[0]?.finalCost || 0);

            const form_option_11th_rows = sumArray(prevState.form_option_11th_rows);
            const form_option_5th_rows = sumArray(prevState.form_option_5th_rows);
            const form_option_6th_rows = sumArray(prevState.form_option_6th_rows);
            const form_option_7th_rows = sumArray(prevState.form_option_7th_rows);
            const form_option_8th_rows = sumArray(prevState.form_option_8th_rows);
            const form_option_9th_rows = sumArray(prevState.form_option_9th_rows);
            const form_option_10th_rows = sumArray(prevState.form_option_10th_rows);
            const form_option_13th_rows = sumArray(prevState.form_option_13th_rows);
            const form_option_12th_rows = state.form_option_12th_rows.reduce(
                (sum, item) => sum + (parseFloat(item.income_cotton) || 0),
                0
            );

            console.log("totalIncomeCotton", form_option_13th_rows);
            const totalTransportCost = prevState.form_option_12th_rows.reduce(
                (sum, item) => sum + (parseFloat(item.transport_cost) || 0),
                0
            );


            // 🔹 D calculation
            const D =
                water_management_cost +
                crop_details_cost +
                form_option_11th_rows +
                form_option_5th_rows +
                form_option_6th_rows +
                form_option_7th_rows +
                form_option_8th_rows +
                form_option_9th_rows +
                form_option_10th_rows +
                form_option_13th_rows +
                form_option_14th_rows +
                totalTransportCost

            // 🔹 Get current B
            const B = Number(
                prevState.cotton_income_details_arr.find(i => i.id === "B")?.value || 0
            );

            // 🔹 A, C, E
            const A = form_option_12th_rows;
            const C = A + B;
            const E = Math.abs(C - D);
            // negative allowed

            // 🔹 Get existing values
            const getVal = id =>
                Number(prevState.cotton_income_details_arr.find(i => i.id === id)?.value || 0);

            // 🔹 Prevent unnecessary rerender
            if (
                getVal("A") === A &&
                getVal("C") === C &&
                getVal("D") === D &&
                getVal("E") === E
            ) {
                return prevState;
            }

            return {
                ...prevState,
                cotton_income_details_arr: prevState.cotton_income_details_arr.map(item => {
                    if (item.id === "A") return { ...item, value: A };
                    if (item.id === "C") return { ...item, value: C };
                    if (item.id === "D") return { ...item, value: D };
                    if (item.id === "E") return { ...item, value: E };
                    return item;
                })
            };
        });
    }, [
        state.water_manage_arr,
        state.crop_details_arr,
        state.form_option_11th_rows,
        state.form_option_5th_rows,
        state.form_option_6th_rows,
        state.form_option_7th_rows,
        state.form_option_8th_rows,
        state.form_option_9th_rows,
        state.form_option_10th_rows,
        state.form_option_12th_rows,
        state.form_option_13th_rows,
        state.form_option_14th_rows
    ]);


    const RequiredLabel = ({ text }) => (
        <span>
            <span style={{ color: "red", fontWeight: "bold" }}>*</span> {text}
        </span>
    );

    const addRow5th = () => {
        setState(prevState => {
            const currentIds = prevState.form_option_5th_rows.map(item => parseInt(item.id));
            const nextId = currentIds?.length > 0 ? Math.max(...currentIds) + 1 : 1;
            return {
                ...prevState,
                form_option_5th_rows: [
                    ...prevState.form_option_5th_rows,
                    { id: nextId.toString(), type_work: '', equpment_cost: '', fuel_ltrs: '', fuel_cost: '', labour_cost: '', total_cost: '', estatus: 1 }
                ],
            };
        });
    };

    const addRow6th = () => {
        setState(prevState => {
            const currentIds = prevState.form_option_6th_rows.map(item => parseInt(item.id));
            const nextId = currentIds?.length > 0 ? Math.max(...currentIds) + 1 : 1;
            return {
                ...prevState,
                form_option_6th_rows: [
                    ...prevState.form_option_6th_rows,
                    { id: nextId.toString(), types: '', variety: "", noOfpackets: '', seedPrice: '', totalSeedCost: '', labourCost: '', total_cost: '', estatus: 1 }
                ]
            };
        });
    };

    const addRow7th = () => {
        setState(prevState => {
            const currentIds = prevState.form_option_7th_rows.map(item => parseInt(item.id));
            const nextId = currentIds?.length > 0 ? Math.max(...currentIds) + 1 : 1;
            return {
                ...prevState,
                form_option_7th_rows: [
                    ...prevState.form_option_7th_rows,
                    { id: nextId.toString(), workDetails: '', name: '', quantity: '', noOfLabours: '', total_cost: '', estatus: 1 }
                ]
            };
        });
    };

    const addRow8th = () => {
        setState(prevState => {
            const currentIds = prevState.form_option_8th_rows.map(item => parseInt(item.id));
            const nextId = currentIds?.length > 0 ? Math.max(...currentIds) + 1 : 1;

            return {
                ...prevState,
                form_option_8th_rows: [
                    ...prevState.form_option_8th_rows,
                    { id: nextId.toString(), typeOf: '', quantity: '', fertilizerCost: '', labourCost: '', totalLabourChargesInOrganicInfo: "", total_cost: '', estatus: 1 }
                ]
            };
        });
    };

    const addRow9th = () => {
        setState(prevState => {
            const currentIds = prevState.form_option_9th_rows.map(item => parseInt(item.id));
            const nextId = currentIds?.length > 0 ? Math.max(...currentIds) + 1 : 1;
            return {
                ...prevState,
                form_option_9th_rows: [
                    ...prevState.form_option_9th_rows,
                    { id: nextId.toString(), pesticide_name: '', quantity: '', costOfPesticide: '', labourCost: '', total_cost: '', estatus: 1 }
                ]
            };
        });
    };

    const addRow10th = () => {
        setState(prevState => {
            const currentIds = prevState.form_option_10th_rows.map(item => parseInt(item.id));
            const nextId = currentIds?.length > 0 ? Math.max(...currentIds) + 1 : 1;
            return {
                ...prevState,
                form_option_10th_rows: [
                    ...prevState.form_option_10th_rows,
                    { id: nextId.toString(), practices: '', quantity: '', cost: '', estatus: 1 }
                ]
            };
        });
    };

    const addRow11th = () => {
        setState(prevState => {
            const currentIds = prevState.form_option_11th_rows.map(item => parseInt(item.id));
            const nextId = currentIds?.length > 0 ? Math.max(...currentIds) + 1 : 1;

            return {
                ...prevState,
                form_option_11th_rows: [
                    ...prevState.form_option_11th_rows,
                    { id: nextId.toString(), labour_count: '', labour_rate: '', totalLabourChargesInCottonHarvestingInfo: "", yield: '', cotton_colour_bags: '', greeding_segrigation: '', total_cost: '', estatus: 1 }
                ]
            };
        });
    };

    const addRow12th = () => {
        setState(prevState => {
            const currentIds = prevState.form_option_12th_rows.map(item => parseInt(item.id));
            const nextId = currentIds?.length > 0 ? Math.max(...currentIds) + 1 : 1;

            return {
                ...prevState,
                form_option_12th_rows: [
                    ...prevState.form_option_12th_rows,
                    { id: nextId.toString(), date: '', sold_cotton: '', ginner: '', cotton_quantity: '', rate: '', income_cotton: '', transport_cost: '', other_cost: '', estatus: 1, total_cost: '' }
                ]
            };
        });
    };

    return (
        <Box>

            <Card elevation={6}>

                <Box
                    display="flex"
                    alignItems="center"
                    p={1}
                >
                    <CustomButton
                        label="Back"
                        status={false}
                        onClick={() => navigate(-1)}
                        icon={<ArrowBackIcon />}
                    />
                </Box>

                <Divider sx={{ my: 0, bgcolor: '#f5f1f1ff' }} />

                <CardContent>
                    <Grid container spacing={1}>
                        {[
                            { id: 1, label: "Year", value: year },
                            user?.level_id === 1 ? { id: 2, label: "Village", value: village_name } : { id: 2, label: "Group", value: group_name },
                            { id: 3, label: "Farmer", value: farmer_name }
                        ].map((item) => (
                            <Grid item size={{ xs: 12, md: 4 }} key={item.id}>
                                <TextField value={item.value} disabled fullWidth size="small" sx={{
                                    "& .MuiInputBase-input": {
                                        color: "#000",        // value text color
                                    },
                                    "& .Mui-disabled .MuiInputBase-input": {
                                        WebkitTextFillColor: "#000",   // important for disabled
                                    },
                                    // background for disabled
                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                        backgroundColor: "#e5e5e5",      // change to what you want
                                    },
                                    "& .MuiInputLabel-root": {
                                        color: "#000",
                                        fontWeight: 700, // thick black
                                    },
                                }} />
                            </Grid>
                        ))}
                    </Grid>

                    {/* Land Information */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={1}>
                            Land Information :  <span style={{ color: "red" }}>{state.landDetailsError}</span>
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>

                                {/* Soil Type */}
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <SingleSelect
                                        name="soil_type"
                                        label={<RequiredLabel text="Soil Type" />}
                                        options={cottonData.getSoilType}
                                        value={
                                            cottonData.getSoilType.find(
                                                option => option.label === state.land_details_arr[0].soil_type
                                            )?.value || ""
                                        }
                                        onChange={handleLandChange}
                                    />
                                </Grid>

                                {/* Soil Testing */}
                                <Grid item size={{ xs: 12, md: 3 }} sx={{
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                    <FormControl>
                                        <FormLabel sx={{ fontWeight: "bold" }}>
                                            <RequiredLabel text="Soil Testing" />
                                        </FormLabel>

                                        <RadioGroup
                                            row
                                            name="soil_test"
                                            value={state.land_details_arr[0]?.soil_test ? "Yes" : "No"}
                                            onChange={(e) => handleLandChange("soil_test", e.target.value)}
                                        >
                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>

                                {/* Total Land Holding */}
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="total_land"
                                        label={<RequiredLabel text="Total Land holding" />}
                                        value={state.land_details_arr[0].total_land}
                                        onChange={(e) => handleLandChange(e.target.name, e.target.value)}
                                    />
                                </Grid>

                                {/* BCI Cotton Land Holding */}
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        name="BCI_land"
                                        label={<RequiredLabel text="BCI Cotton Land holding" />}
                                        value={state.land_details_arr[0].BCI_land}
                                        onChange={(e) => handleLandChange(e.target.name, e.target.value)}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Water Management */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Water Management :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <SingleSelect
                                        name="irrigation_facility"
                                        label="Select Irrigation Facility"
                                        options={cottonData.irrigation_Facility}
                                        value={cottonData.irrigation_Facility.find(option => option.label === state.water_manage_arr[0]?.irrigation_facility)?.value || ""}
                                        onChange={handleWaterChange}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <SingleSelect
                                        name="source_irrigation"
                                        label="Source Irrigation"
                                        options={cottonData.source_irrigation}
                                        value={cottonData.source_irrigation.find(option => option.label === state.water_manage_arr[0]?.source_irrigation)?.value || ""}
                                        onChange={handleWaterChange}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <TextField
                                        size="small"
                                        label="Irrigating / hr"
                                        fullWidth
                                        type="text"
                                        name="irrigating_hr"
                                        onChange={(e) => handleWaterChange(e.target.name, e.target.value)}
                                        value={state.water_manage_arr[0]?.irrigating_hr}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 3 }}>
                                    <TextField
                                        size="small"
                                        label="Irrigation L/cm"
                                        fullWidth
                                        type="text"
                                        name="irrigation_cm"
                                        onChange={(e) => handleWaterChange(e.target.name, e.target.value)}
                                        value={state.water_manage_arr[0]?.irrigation_cm}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 3 }} mt={1}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Labour Cost"
                                        type="text"
                                        name="labour_cost"
                                        value={state.water_manage_arr[0]?.labour_cost || ""}
                                        onChange={(e) => handleWaterChange(e.target.name, e.target.value.replace(/\D/g, "").slice(0, 50))}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 3 }} mt={1}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Fuel Cost"
                                        type="text"
                                        name="fuel_cost"
                                        value={state.water_manage_arr[0]?.fuel_cost || ""}
                                        onChange={(e) => handleWaterChange(e.target.name, e.target.value.replace(/\D/g, "").slice(0, 50))}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 3 }} mt={1}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Elec... Cost"
                                        type="text"
                                        name="ele_cost"
                                        value={state.water_manage_arr[0]?.ele_cost || ""}
                                        onChange={(e) => handleWaterChange(e.target.name, e.target.value.replace(/\D/g, "").slice(0, 50))}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 3 }} mt={1}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        label="Total Cost"
                                        type="text"
                                        name="total_cost"
                                        value={state.water_manage_arr[0]?.total_cost || ""}
                                        disabled
                                        sx={{
                                            "& .MuiInputBase-input": {
                                                color: "#000",        // value text color
                                            },
                                            "& .Mui-disabled .MuiInputBase-input": {
                                                WebkitTextFillColor: "#000",   // important for disabled
                                            },
                                            // background for disabled
                                            "& .MuiOutlinedInput-root.Mui-disabled": {
                                                backgroundColor: "#e5e5e5",      // change to what you want
                                            },
                                            "& .MuiInputLabel-root": {
                                                color: "#000",
                                                fontWeight: 700, // thick black
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.water_manage_arr.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>


                    {/* Details of InterCrop */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Details of InterCrop :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {
                                    [
                                        { id: 1, type: "select", name: "inter_crop", value: cottonData.inter_crop.find(option => option.label === state.crop_details_arr[0]?.inter_crop)?.value || "", options: cottonData.inter_crop, label: "Select Inter Crop" },
                                        { id: 2, type: "select", name: "ratio_inter_crop", value: ratioOptions.find(option => option.label === state.crop_details_arr[0]?.ratio_inter_crop)?.value || "", options: ratioOptions, label: "Ratio of inter crop" },
                                        { id: 3, type: "text", name: "seed_cost", value: state.crop_details_arr[0]?.seed_cost, label: "Seed Cost" },
                                        { id: 4, type: "text", name: "labour_cost", value: state.crop_details_arr[0]?.labour_cost, label: "Labour Cost" },
                                        { id: 5, type: "text", name: "other_cost", value: state.crop_details_arr[0]?.other_cost, label: "Other Cost" },
                                        { id: 6, type: "text", name: "total_cost", value: state.crop_details_arr[0]?.total_cost, label: "Total Cost" },
                                    ].map((field, index) => (
                                        <Grid key={index} item size={{ xs: 12, md: 3 }} mt={1}>
                                            {
                                                field.type === "select" ? (
                                                    <SingleSelect
                                                        name={field.name}
                                                        label={field.label}
                                                        options={field.options || []}
                                                        value={field.value || ""}
                                                        onChange={handleCropChange}
                                                    />
                                                ) : (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name={field.name}
                                                        // label={field.label}
                                                        type={field.type}
                                                        value={field.value || ""}
                                                        disabled={field.id === 6 ? true : false}
                                                        label={[6].includes(field.id) ? "" : field.label}
                                                        placeholder={![6].includes(field.id) ? "" : field.label}
                                                        sx={field.id !== 6 ? {} : {
                                                            "& .MuiInputBase-input": {
                                                                color: "#000",        // value text color
                                                            },
                                                            "& .Mui-disabled .MuiInputBase-input": {
                                                                WebkitTextFillColor: "#000",   // important for disabled
                                                            },
                                                            // background for disabled
                                                            "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                backgroundColor: "#e5e5e5",      // change to what you want
                                                            },
                                                            "& .MuiInputLabel-root": {
                                                                color: "#000",
                                                                fontWeight: 700, // thick black
                                                            },
                                                        }}
                                                        onChange={(e) => handleCropChange(e.target.name, e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                    />
                                                )
                                            }
                                        </Grid>
                                    ))
                                }

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.crop_details_arr.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Land Preparation */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Land Preparation :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {
                                    state.form_option_5th_rows.map((item, index) => (
                                        item.estatus === 1 ? (
                                            <>
                                                {
                                                    [
                                                        { id: 1, name: "type_work", value: item.type_work, label: "Type Of work", },
                                                        { id: 2, name: "equpment_cost", value: item.equpment_cost, label: "Equipment Cost", },
                                                        { id: 3, name: "labour_cost", value: item.labour_cost, label: "Labour Cost", },
                                                        { id: 4, name: "total_cost", value: item.total_cost, label: "Total Cost", },
                                                    ].map((field, fieldIndex) => (
                                                        <Grid key={fieldIndex} item size={{ xs: 12, md: 2.5 }}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label={field.label}
                                                                type="text"
                                                                name={field.name}
                                                                value={field.value}
                                                                disabled={field.id === 4 ? true : false}
                                                                sx={field.id === 4 ? {
                                                                    "& .MuiInputBase-input": {
                                                                        color: "#000",        // value text color
                                                                    },
                                                                    "& .Mui-disabled .MuiInputBase-input": {
                                                                        WebkitTextFillColor: "#000",   // important for disabled
                                                                    },
                                                                    // background for disabled
                                                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                        backgroundColor: "#e5e5e5",      // change to what you want
                                                                    },
                                                                    "& .MuiInputLabel-root": {
                                                                        color: "#000",
                                                                        fontWeight: 700, // thick black
                                                                    },
                                                                } : {}}
                                                                onChange={(e) => handleAddRowFormChange(index, field.name, '5th', field.id === 1 ? e.target.value.slice(0, 50) : e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                            />
                                                        </Grid>
                                                    ))
                                                }

                                                {
                                                    state.form_option_5th_rows.filter(item => item.estatus === 1)?.length > 1 ? (
                                                        <Grid item xs={12} md={2.5}>
                                                            <CustomButton
                                                                label="Delete"
                                                                status={false}
                                                                icon={<DeleteIcon color="white" />}
                                                                onClick={(event) => handleDelete(event, index, '5th')}
                                                            />
                                                        </Grid>
                                                    ) : null
                                                }
                                            </>
                                        ) : null
                                    ))
                                }
                            </Grid>

                            <Grid container spacing={1} mt={2}>
                                <Grid item size={{ xs: 12, md: 1 }}>
                                    <CustomButton
                                        label="Add"
                                        status={false}
                                        onClick={addRow5th}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_5th_rows.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Paper>
                    </Box>

                    {/* Details of cotton seeds  */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Details of cotton seeds  :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {
                                    state.form_option_6th_rows.map((item, index) => (
                                        item.estatus === 1 ? (
                                            <>
                                                {
                                                    [
                                                        { id: 1, name: "types", label: "Type of Seed", value: cottonData.seedsType.find(option => option.label === item.types)?.value || "", options: cottonData.seedsType },
                                                        { id: 2, name: "variety", label: "Variety", value: item.variety, },
                                                        { id: 3, name: "noOfpackets", label: "No. of packets", value: item.noOfpackets, },
                                                        { id: 4, name: "seedPrice", label: "Cost of one seed packet", value: item.seedPrice, },
                                                        { id: 5, name: "totalSeedCost", label: "Cost of seeds", value: item.totalSeedCost, },
                                                        { id: 6, name: "labourCost", label: "Labour Cost", value: item.labourCost, },
                                                        { id: 7, name: "total_cost", label: "Total Cost", value: item.total_cost, },
                                                    ].map((field, fieldIndex) => (
                                                        <Grid key={fieldIndex} item size={{ xs: 12, md: 3 }} mt={0.5} mb={0.5}>
                                                            {
                                                                field.id === 1 ? (
                                                                    <FormControl fullWidth size="small">
                                                                        <InputLabel>{field.label}</InputLabel>
                                                                        <Select
                                                                            label={field.label}
                                                                            name={field.name}
                                                                            value={field.value || ""}
                                                                            onChange={(e) =>
                                                                                handleAddRowFormChange(index, "types", "6th", e.target.value)
                                                                            }
                                                                        >
                                                                            {(field.options || []).map((opt, i) => (
                                                                                <MenuItem key={i} value={opt.value}>
                                                                                    {opt.label}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                ) : (
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        label={[5, 7].includes(field.id) ? "" : field.label}
                                                                        placeholder={![5, 7].includes(field.id) ? "" : field.label}
                                                                        type="text"
                                                                        name={field.name}
                                                                        value={field.value}
                                                                        disabled={[5, 7].includes(field.id) ? true : false}
                                                                        sx={![5, 7].includes(field.id) ? {} : {
                                                                            "& .MuiInputBase-input": {
                                                                                color: "#000",        // value text color
                                                                            },
                                                                            "& .Mui-disabled .MuiInputBase-input": {
                                                                                WebkitTextFillColor: "#000",   // important for disabled
                                                                            },
                                                                            // background for disabled
                                                                            "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                                backgroundColor: "#e5e5e5",      // change to what you want
                                                                            },
                                                                            "& .MuiInputLabel-root": {
                                                                                color: "#000",
                                                                                fontWeight: 700, // thick black
                                                                            },
                                                                        }}
                                                                        onChange={(e) => handleAddRowFormChange(index, field.name, '6th', [2].includes(field.id) ? e.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 50) : e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                                    />
                                                                )
                                                            }
                                                        </Grid>
                                                    ))
                                                }

                                                {
                                                    state.form_option_6th_rows.filter(item => item.estatus === 1)?.length > 1 ? (
                                                        <Grid item xs={12} md={4} mt={0.5} mb={0.5} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                                            <CustomButton
                                                                label="Delete"
                                                                status={false}
                                                                icon={<DeleteIcon color="white" />}
                                                                onClick={(event) => handleDelete(event, index, '6th')}
                                                            />
                                                        </Grid>
                                                    ) : null
                                                }
                                            </>
                                        ) : null
                                    ))}
                            </Grid>


                            <Grid container spacing={1} mt={2}>
                                <Grid item size={{ xs: 12, md: 1 }}>
                                    <CustomButton
                                        label="Add"
                                        status={false}
                                        onClick={addRow6th}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_6th_rows.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Gap Filling & Weeding  */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        {/* <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Gap Filling & Weeding  :
                        </Typography> */}

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            {/* <Box sx={{ textAlign: "center" }}>
                                  <Typography variant="h6" mb={3}>Using of any Herbicide</Typography>
                                </Box> */}
                            <Grid container spacing={1}>
                                {
                                    state.form_option_7th_rows.map((item, index) => (
                                        item.estatus === 1 ? (
                                            <>
                                                {
                                                    [
                                                        { id: 1, name: "workDetails", value: item.workDetails, label: "Type Of work", },

                                                        ...index === 2 ? [{ id: 2, name: "name", value: item.name, label: "Name", },] :
                                                            [{ id: 4, name: "noOfLabours", value: item.noOfLabours, label: "Number of Labours", }],

                                                        ...index === 2 ? [{ id: 5, name: "quantity", value: item.quantity, label: "Quantity" },] : [
                                                            { id: 5, name: "labourCost", value: item.labourCost, label: "Labour Cost" },
                                                        ],
                                                        ...index === 2 ? [{ id: 7, name: "total_cost", value: item.total_cost, label: "Cost", }] :
                                                            [{ id: 6, name: "totalLabourChargesInGapFilling", value: item.totalLabourChargesInGapFilling, label: "Total Labour Charges", },]
                                                        // { id: 6, name: "total_cost", value: item.total_cost, label: "Total Cost", },

                                                    ].map((field, fieldIndex) => (
                                                        <Grid key={fieldIndex} item size={{ xs: 12, md: 3 }} mt={1}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                label={field.label}
                                                                type="text"
                                                                name={field.name}
                                                                value={field.value}
                                                                disabled={[1, 6].includes(field.id) ? true : false}
                                                                onChange={(e) => handleAddRowFormChange(index, field.name, '7th', [1, 2, 3].includes(field.id) ? e.target.value.slice(0, 50) : e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                                sx={![1, 6].includes(field.id) ? {} : {
                                                                    "& .MuiInputBase-input": {
                                                                        color: "#000",        // value text color
                                                                    },
                                                                    "& .Mui-disabled .MuiInputBase-input": {
                                                                        WebkitTextFillColor: "#000",   // important for disabled
                                                                    },
                                                                    // background for disabled
                                                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                        backgroundColor: "#e5e5e5",      // change to what you want
                                                                    },
                                                                    "& .MuiInputLabel-root": {
                                                                        color: "#000",
                                                                        fontWeight: 700, // thick black
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>
                                                    ))
                                                }

                                                {/* {
                                            state.form_option_7th_rows.filter(item => item.estatus === 1)?.length > 1 ? (
                                              <Grid item xs={12} md={2}>
                                                <CustomButton
                                                  label="Delete"
                                                  status={false}
                                                  icon={<DeleteIcon color="white" />}
                                                  onClick={(event) => handleDelete(event, index, '7th')}
                                                />
                                              </Grid>
                                            ) : null
                                          } */}
                                            </>
                                        ) : null
                                    ))
                                }
                            </Grid>


                            <Grid container spacing={1} mt={2}>
                                {/* 
                                 <Grid item size={{ xs: 12, md: 1 }}>
                                    <CustomButton
                                      label="Add"
                                      status={false}
                                      onClick={addRow7th}
                                    />
                                  </Grid> */}

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_7th_rows.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Organic and Chemical Fertilizers Information */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Organic and Chemical Fertilizers Information   :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {
                                    state.form_option_8th_rows.map((item, index) => (
                                        item.estatus === 1 ? (
                                            <>
                                                {
                                                    [
                                                        { id: 1, name: "fertilizer", label: "Type of Fertilizers", value: cottonData.Fertilizers.find(option => option.label === item.typeOf)?.value || "", options: cottonData.Fertilizers },
                                                        { id: 2, name: "fertilizerCost", label: "Fertilizer cost", value: item.fertilizerCost, },
                                                        { id: 3, name: "quantity", label: "Quantity (kgs / L / Bags)", value: item.quantity, },
                                                        { id: 4, name: "totalLabourChargesInOrganicInfo", label: "Total Fertilizer Cost", value: item.totalLabourChargesInOrganicInfo, },
                                                        { id: 5, name: "labourCost", label: "Labour cost", value: item.labourCost, },
                                                        // { id: 6, name: "total_cost", label: "Total cost", value: item.total_cost, },
                                                    ].map((field, fieldIndex) => (
                                                        <Grid key={fieldIndex} item size={{ xs: 12, md: 2 }} mt={state.form_option_8th_rows.filter(item => item.estatus === 1)?.length > 1 ? 1 : 0}>
                                                            {
                                                                field.id === 1 ? (
                                                                    <FormControl fullWidth size="small">
                                                                        <InputLabel>{field.label}</InputLabel>
                                                                        <Select
                                                                            label={field.label}
                                                                            name={field.name}
                                                                            value={field.value || ""}
                                                                            onChange={(e) =>
                                                                                handleAddRowFormChange(index, "fertilizer", "8th", e.target.value)
                                                                            }
                                                                        >
                                                                            {(field.options || []).map((opt, i) => (
                                                                                <MenuItem key={i} value={opt.value}>
                                                                                    {opt.label}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                ) : (
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        type="text"
                                                                        name={field.name}
                                                                        value={field.value}
                                                                        disabled={[4, 6].includes(field.id) ? true : false}
                                                                        // label={[5, 6].includes(field.id) ? "" : field.label}
                                                                        // placeholder={![5, 6].includes(field.id) ? "" : field.label}
                                                                        label={field.label}
                                                                        sx={![4, 6].includes(field.id) ? {} : {
                                                                            "& .MuiInputBase-input": {
                                                                                color: "#000",        // value text color
                                                                            },
                                                                            "& .Mui-disabled .MuiInputBase-input": {
                                                                                WebkitTextFillColor: "#000",   // important for disabled
                                                                            },
                                                                            // background for disabled
                                                                            "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                                backgroundColor: "#e5e5e5",      // change to what you want
                                                                            },
                                                                            "& .MuiInputLabel-root": {
                                                                                color: "#000",
                                                                                fontWeight: 700, // thick black
                                                                            },
                                                                        }}
                                                                        onChange={(e) => handleAddRowFormChange(index, field.name, '8th', field.id === 3 ? e.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 50) : e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                                    />
                                                                )
                                                            }
                                                        </Grid>
                                                    ))
                                                }

                                                {
                                                    state.form_option_8th_rows.filter(item => item.estatus === 1)?.length > 1 ? (
                                                        <Grid item xs={12} md={2} mt={state.form_option_8th_rows.filter(item => item.estatus === 1)?.length > 1 ? 1 : 0}>
                                                            <CustomButton
                                                                label="Delete"
                                                                status={false}
                                                                icon={<DeleteIcon color="white" />}
                                                                onClick={(event) => handleDelete(event, index, '8th')}
                                                            />
                                                        </Grid>
                                                    ) : null
                                                }
                                            </>
                                        ) : null
                                    ))}
                            </Grid>


                            <Grid container spacing={1} mt={2}>
                                <Grid item size={{ xs: 12, md: 1 }}>
                                    <CustomButton
                                        label="Add"
                                        status={false}
                                        onClick={addRow8th}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_8th_rows.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>


                    {/* Details of Usage of HHP's and Cocktails */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Details of Usage of HHP's and Cocktails :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {[
                                    { id: 1, type: "radio", name: "usingHHP", label: "Are you using HHP's", options: [{ id: 1, label: "Yes", value: "Yes" }, { id: 2, label: "No", value: "No" }], value: state.form_option_13th_rows[0].usingHHP },
                                    ...state.form_option_13th_rows[0]?.usingHHP === true ? [{ id: 2, type: "select", options: cottonData.HHP_Names, label: "HHP Name", value: cottonData.HHP_Names.find(option => option.label === state.form_option_13th_rows[0].HHP_name)?.value || "", name: "HHP_name" },] : [],
                                    { id: 3, name: "HHP_quantity", label: "Quanity Kg / L", value: state.form_option_13th_rows[0].HHP_quantity, },
                                    ...state.form_option_13th_rows[0]?.usingHHP === true ? [{ id: 4, name: "hhp_cost", label: "Cost", value: state.form_option_13th_rows[0].hhp_cost, }] : [],

                                    { id: 5, type: "radio", name: "usingCocktails", label: "Are you using cocktails", options: [{ id: 1, label: "Yes", value: "Yes" }, { id: 2, label: "No", value: "No" }], value: state.form_option_13th_rows[0].usingCocktails },
                                    ...state.form_option_13th_rows[0]?.usingCocktails === true ? [{ id: 6, name: "cocktailsName", value: state.form_option_13th_rows[0].cocktailsName, label: "Cocktail Name" }] : [],
                                    { id: 7, name: "cock_quantity", label: "Quanity Kg / L", value: state.form_option_13th_rows[0].cock_quantity },
                                    ...state.form_option_13th_rows[0]?.usingCocktails === true ? [{ id: 8, name: "cocktailsCost", label: "Cost", value: state.form_option_13th_rows[0].cocktailsCost, }] : [],

                                    { id: 9, type: "radio", name: "awareness_PAN_Group", label: "Do you have awareness on the PAN group - 3 pesticides", options: [{ id: 1, label: "Yes", value: "Yes" }, { id: 2, label: "No", value: "No" }], value: state.form_option_13th_rows[0].awareness_PAN_Group },

                                ].map((field, fieldIndex) => (
                                    <Grid key={fieldIndex} item size={{ xs: 12, md: field.type === "radio" ? 3 : 3 }}>
                                        {
                                            field.type === "select" ? (
                                                <FormControl fullWidth size="small">
                                                    <InputLabel>{field.label}</InputLabel>
                                                    <Select
                                                        label={field.label}
                                                        name={field.name}
                                                        value={field.value || ""}
                                                        onChange={handleHhpCocktails}
                                                    >
                                                        {(field.options || []).map((opt, i) => (
                                                            <MenuItem key={i} value={opt.value}>
                                                                {opt.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            ) : field.type === "radio" ? (
                                                <FormControl>
                                                    <FormLabel sx={{ fontWeight: "bold" }}>
                                                        {field.label}
                                                    </FormLabel>

                                                    <RadioGroup
                                                        row
                                                        name={field.name}
                                                        value={field.value ? "Yes" : "No"}
                                                        onChange={handleHhpCocktails}
                                                    >
                                                        {field.options.map(opt => (
                                                            <FormControlLabel
                                                                key={opt.id}
                                                                value={opt.value}
                                                                control={<Radio color="success" />}
                                                                label={opt.label}
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                </FormControl>
                                            ) : (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label={field.label}
                                                    type="text"
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={handleHhpCocktails}
                                                />
                                            )
                                        }
                                    </Grid>
                                ))}
                            </Grid>
                            <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                    {state.form_option_13th_rows.reduce(
                                        (sum, item) => sum + parseFloat(item.total_cost || 0),
                                        0
                                    )}
                                </Typography>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Pesticides Information */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Pesticides Information  :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {
                                    state.form_option_9th_rows.map((item, index) => (
                                        item.estatus === 1 ? (
                                            <>
                                                {
                                                    [
                                                        { id: 1, name: "pesticide", label: "Pesticide Name", value: cottonData.Pesticides.find(option => option.label === item.pesticide_name)?.value || "", options: cottonData.Pesticides },
                                                        { id: 2, name: "quantity", label: "Quantity (kgs / L )", value: item.quantity, },
                                                        { id: 3, name: "costOfPesticide", label: "Cost of Pesticide", value: item.costOfPesticide, },
                                                        { id: 4, name: "labourCost", label: "Labour cost", value: item.labourCost, },
                                                        { id: 5, name: "total_cost", label: "Total cost", value: item.total_cost, },
                                                    ].map((field, fieldIndex) => (
                                                        <Grid key={fieldIndex} item size={{ xs: 12, md: state.form_option_9th_rows.filter(item => item.estatus === 1)?.length > 1 ? 2 : 3 }}>
                                                            {
                                                                field.id === 1 ? (
                                                                    <FormControl fullWidth size="small">
                                                                        <InputLabel>{field.label}</InputLabel>
                                                                        <Select
                                                                            label={field.label}
                                                                            name={field.name}
                                                                            value={field.value || ""}
                                                                            onChange={(e) =>
                                                                                handleAddRowFormChange(index, "pesticide", "9th", e.target.value)
                                                                            }
                                                                        >
                                                                            {(field.options || []).map((opt, i) => (
                                                                                <MenuItem key={i} value={opt.value}>
                                                                                    {opt.label}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                ) : (
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        label={[5].includes(field.id) ? "" : field.label}
                                                                        placeholder={![5].includes(field.id) ? "" : field.label}
                                                                        type="text"
                                                                        name={field.name}
                                                                        value={field.value}
                                                                        disabled={[5].includes(field.id) ? true : false}
                                                                        sx={[5].includes(field.id) ? {
                                                                            "& .MuiInputBase-input": {
                                                                                color: "#000",        // value text color
                                                                            },
                                                                            "& .Mui-disabled .MuiInputBase-input": {
                                                                                WebkitTextFillColor: "#000",   // important for disabled
                                                                            },
                                                                            // background for disabled
                                                                            "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                                backgroundColor: "#e5e5e5",      // change to what you want
                                                                            },
                                                                            "& .MuiInputLabel-root": {
                                                                                color: "#000",
                                                                                fontWeight: 700, // thick black
                                                                            },
                                                                        } : {}}
                                                                        onChange={(e) => handleAddRowFormChange(index, field.name, '9th', field.id === 2 ? e.target.value.slice(0, 50) : e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                                    />
                                                                )
                                                            }
                                                        </Grid>
                                                    ))
                                                }

                                                {
                                                    state.form_option_9th_rows.filter(item => item.estatus === 1)?.length > 1 ? (
                                                        <Grid item xs={12} md={2}>
                                                            <CustomButton
                                                                label="Delete"
                                                                status={false}
                                                                icon={<DeleteIcon color="white" />}
                                                                onClick={(event) => handleDelete(event, index, '9th')}
                                                            />
                                                        </Grid>
                                                    ) : null
                                                }
                                            </>
                                        ) : null
                                    ))}
                            </Grid>


                            <Grid container spacing={1} mt={2}>
                                <Grid item size={{ xs: 12, md: 1 }}>
                                    <CustomButton
                                        label="Add"
                                        status={false}
                                        onClick={addRow9th}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_9th_rows.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Better management practices */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Better management practices :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {
                                    state.form_option_10th_rows.map((item, index) => (
                                        item.estatus === 1 ? (
                                            <>
                                                {
                                                    [
                                                        { id: 1, name: "pesticide", label: "Particulars or Name of Activity", value: cottonData.Practices.find(option => option.label === item.practices)?.value || "", options: cottonData.Practices },
                                                        { id: 2, name: "quantity", label: "Quantity", value: item.quantity, },
                                                        { id: 3, name: "cost", label: "Cost", value: item.cost, },
                                                        { id: 4, name: "total_cost", label: "Total cost", value: item.total_cost, },
                                                    ].map((field, fieldIndex) => (
                                                        <Grid key={fieldIndex} item size={{ xs: 12, md: state.form_option_10th_rows.filter(item => item.estatus === 1)?.length > 1 ? 2.5 : 3 }}>
                                                            {
                                                                field.id === 1 ? (
                                                                    <FormControl fullWidth size="small">
                                                                        <InputLabel>{field.label}</InputLabel>
                                                                        <Select
                                                                            label={field.label}
                                                                            name={field.name}
                                                                            value={field.value || ""}
                                                                            onChange={(e) =>
                                                                                handleAddRowFormChange(index, "practices", "10th", e.target.value)
                                                                            }
                                                                        >
                                                                            {(field.options || []).map((opt, i) => (
                                                                                <MenuItem key={i} value={opt.value}>
                                                                                    {opt.label}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </FormControl>
                                                                ) : (
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        label={[5].includes(field.id) ? "" : field.label}
                                                                        placeholder={![5].includes(field.id) ? "" : field.label}
                                                                        type="text"
                                                                        name={field.name}
                                                                        value={field.value}
                                                                        disabled={[5].includes(field.id) ? true : false}
                                                                        sx={[5].includes(field.id) ? {
                                                                            "& .MuiInputBase-input": {
                                                                                color: "#000",        // value text color
                                                                            },
                                                                            "& .Mui-disabled .MuiInputBase-input": {
                                                                                WebkitTextFillColor: "#000",   // important for disabled
                                                                            },
                                                                            // background for disabled
                                                                            "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                                backgroundColor: "#e5e5e5",      // change to what you want
                                                                            },
                                                                            "& .MuiInputLabel-root": {
                                                                                color: "#000",
                                                                                fontWeight: 700, // thick black
                                                                            },
                                                                        } : {}}
                                                                        onChange={(e) => handleAddRowFormChange(index, field.name, '10th', field.id === 2 ? e.target.value.slice(0, 50) : e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                                    />
                                                                )
                                                            }
                                                        </Grid>
                                                    ))
                                                }

                                                {
                                                    state.form_option_10th_rows.filter(item => item.estatus === 1)?.length > 1 ? (
                                                        <Grid item xs={12} md={2}>
                                                            <CustomButton
                                                                label="Delete"
                                                                status={false}
                                                                icon={<DeleteIcon color="white" />}
                                                                onClick={(event) => handleDelete(event, index, '10th')}
                                                            />
                                                        </Grid>
                                                    ) : null
                                                }
                                            </>
                                        ) : null
                                    ))}
                            </Grid>


                            <Grid container spacing={1} mt={2}>
                                <Grid item size={{ xs: 12, md: 1 }}>
                                    <CustomButton
                                        label="Add"
                                        status={false}
                                        onClick={addRow10th}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_10th_rows.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Precautions and safety measures to be followed while spraying  */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Precautions and safety measures to be followed while spraying  :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                <Grid item size={{ xs: 12, md: 4 }}>
                                    {/* <MultiSelect
                                          options={cottonData.harmLessOptions.map((item) => ({ value: item.id, label: item.name }))}
                                          value={state.safety_precautions_arr}
                                          onChange={(selectedOptions) => handleMultiSelectionChange(selectedOptions)}
                                          labelledBy={"Select"}
                                          name="precautions"
                                        /> */}

                                    <MultiSelectWithAll
                                        name="precautions"
                                        label="Select"
                                        options={cottonData.harmLessOptions.map((item) => ({ value: item.id, label: item.name }))}
                                        value={state.safety_precautions_arr}
                                        onChange={handleMultiSelectionChange}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Cotton Harvesting & Fiber Quality Information  */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Cotton Harvesting & Fiber Quality Information :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {
                                    state.form_option_11th_rows.map((item, index) => (
                                        item.estatus === 1 ? (
                                            <>
                                                {
                                                    [
                                                        { id: 1, name: "labour_count", value: item.labour_count, label: "Number of Labours", },
                                                        { id: 2, name: "labour_rate", value: item.labour_rate, label: "Labour Rate", },
                                                        { id: 3, name: "totalLabourChargesInCottonHarvestingInfo", value: item.totalLabourChargesInCottonHarvestingInfo, label: "Total Labour Charges", },
                                                        { id: 4, name: "yield", value: item.yield, label: "YIELD (in Kg /Qt)" },
                                                        { id: 5, name: "cotton_colour_bags", value: item.cotton_colour_bags, label: "Cotton / Color Bags", },
                                                        { id: 6, name: "greeding_segrigation", value: item.greeding_segrigation, label: "Greading/Segrigation", },
                                                        { id: 7, name: "total_cost", value: item.total_cost, label: "Total Cost", },
                                                    ].map((field, fieldIndex) => (
                                                        <Grid key={fieldIndex} item size={{ xs: 12, md: 3 }} mt={1} mb={1}>
                                                            <TextField
                                                                fullWidth
                                                                size="small"
                                                                // label={[3].includes(field.id) ? "" : field.label}
                                                                // placeholder={![3].includes(field.id) ? "" : field.label}
                                                                label={field.label}
                                                                type="text"
                                                                name={field.name}
                                                                value={field.value}
                                                                onChange={(e) => handleAddRowFormChange(index, field.name, '11th', [4, 5, 6].includes(field.id) ? e.target.value.slice(0, 50) : e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                                disabled={[3].includes(field.id) ? true : false}
                                                                sx={[3].includes(field.id) ? {
                                                                    "& .MuiInputBase-input": {
                                                                        color: "#000",        // value text color
                                                                    },
                                                                    "& .Mui-disabled .MuiInputBase-input": {
                                                                        WebkitTextFillColor: "#000",   // important for disabled
                                                                    },
                                                                    // background for disabled
                                                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                        backgroundColor: "#e5e5e5",      // change to what you want
                                                                    },
                                                                    "& .MuiInputLabel-root": {
                                                                        color: "#000",
                                                                        fontWeight: 700, // thick black
                                                                    },
                                                                } : {}} />
                                                        </Grid>
                                                    ))
                                                }

                                                {
                                                    state.form_option_11th_rows.filter(item => item.estatus === 1)?.length > 1 ? (
                                                        <Grid item xs={12} md={3} mt={state.form_option_11th_rows.filter(item => item.estatus === 1)?.length > 1 ? 1 : 0}>
                                                            <CustomButton
                                                                label="Delete"
                                                                status={false}
                                                                icon={<DeleteIcon color="white" />}
                                                                onClick={(event) => handleDelete(event, index, '11th')}
                                                            />
                                                        </Grid>
                                                    ) : null
                                                }
                                            </>
                                        ) : null
                                    ))
                                }
                            </Grid>


                            <Grid container spacing={1} mt={2}>
                                <Grid item size={{ xs: 12, md: 1 }}>
                                    <CustomButton
                                        label="Add"
                                        status={false}
                                        onClick={addRow11th}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_11th_rows.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Cotton Sold information */}
                    <Box mt={1} width="100%">
                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            {/* Header */}
                            <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                                Cotton Sold information :
                            </Typography>

                            {
                                state.form_option_12th_rows.map((item, index) => (
                                    item.estatus === 1 ? (
                                        <Paper
                                            key={index}
                                            elevation={3}
                                            sx={{
                                                border: "1px solid #e0e0e0",
                                                p: 2,
                                                borderRadius: 2,
                                                mb: 1.5,
                                            }}
                                        >
                                            <Grid container spacing={1}>
                                                {
                                                    [
                                                        { id: 1, name: "date", type: "date", label: "Select Date", value: item.date, },
                                                        { id: 2, name: "sold_cotton", value: item.sold_cotton, label: "Sold Cotton Place", },
                                                        { id: 3, name: "ginner", value: item.ginner, label: "Name Of the Ginner", },
                                                        { id: 4, name: "cotton_quantity", value: item.cotton_quantity, label: "Cotton Quantity Kg / qt" },
                                                        { id: 5, name: "rate", value: item.rate, label: "RATE/ Qt", },
                                                        { id: 6, name: "income_cotton", value: item.income_cotton, label: "Income on Seed cotton", },
                                                        { id: 7, name: "transport_cost", value: item.transport_cost, label: "Transportation Cost", },
                                                        { id: 8, name: "other_cost", value: item.other_cost, label: "Other Income Cost", },
                                                        { id: 9, name: "total_cost", value: item.total_cost, label: "Total Cost", },
                                                    ].map((field, fieldIndex) => (
                                                        <Grid key={fieldIndex} item size={{ xs: 12, md: 4 }} mt={0.5} mb={0.5}>
                                                            {
                                                                field.type === "date" ? (
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        type={field.type}
                                                                        label={field.label}
                                                                        name={field.name}
                                                                        value={field.value}
                                                                        onChange={(e) =>
                                                                            handleAddRowFormChange(index, field.name, "12th", e.target.value)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        label={[9].includes(field.id) ? "" : field.label}
                                                                        placeholder={![9].includes(field.id) ? "" : field.label}
                                                                        type="text"
                                                                        name={field.name}
                                                                        value={field.value}
                                                                        disabled={[6, 9].includes(field.id) ? true : false}
                                                                        sx={[6, 9].includes(field.id) ? {
                                                                            "& .MuiInputBase-input": {
                                                                                color: "#000",        // value text color
                                                                            },
                                                                            "& .Mui-disabled .MuiInputBase-input": {
                                                                                WebkitTextFillColor: "#000",   // important for disabled
                                                                            },
                                                                            // background for disabled
                                                                            "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                                backgroundColor: "#e5e5e5",      // change to what you want
                                                                            },
                                                                            "& .MuiInputLabel-root": {
                                                                                color: "#000",
                                                                                fontWeight: 700, // thick black
                                                                            },
                                                                        } : {}}
                                                                        onChange={(e) => handleAddRowFormChange(index, field.name, '12th', [2, 3, 4, 5].includes(field.id) ? e.target.value.slice(0, 50) : e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                                    />
                                                                )
                                                            }
                                                        </Grid>
                                                    ))
                                                }

                                                {
                                                    state.form_option_12th_rows.filter(item => item.estatus === 1)?.length > 1 ? (
                                                        <Grid item xs={12} md={3} sx={{ display: "flex", justifyContent: "flex-end", }}>
                                                            <CustomButton
                                                                label="Delete"
                                                                status={false}
                                                                icon={<DeleteIcon color="white" />}
                                                                onClick={(event) => handleDelete(event, index, '12th')}
                                                            />
                                                        </Grid>
                                                    ) : null
                                                }
                                            </Grid>
                                        </Paper>
                                    ) : null
                                ))
                            }

                            <Grid container spacing={1} mt={1}>
                                <Grid item size={{ xs: 12, md: 1 }}>
                                    <CustomButton
                                        label="Add"
                                        status={false}
                                        onClick={addRow12th}
                                    />
                                </Grid>

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_12th_rows.reduce(
                                            (sum, item) => sum + parseFloat(item.total_cost || 0),
                                            0
                                        )}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Fuel Details */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Fuel Details :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                {
                                    [
                                        {
                                            header: "Fuel used for land preparation",
                                            data: state.form_option_14th_rows.map((item, index) => ([
                                                { id: 1, label: "Liters", name: "preparation_fuel_liters", value: item.preparation_fuel_liters, rowIndex: index, disabled: false },
                                                { id: 2, label: "Cost per liters", name: "preparation_fuel_cost", value: item.preparation_fuel_cost, rowIndex: index, disabled: false },
                                                { id: 3, label: "Total Cost", name: "total_preparation_fuel_cost", value: item.total_preparation_fuel_cost, rowIndex: index, disabled: true },
                                            ]))
                                        },
                                        {
                                            header: "Fuel used for Transportation",
                                            data: state.form_option_14th_rows.map((item, index) => ([
                                                { id: 1, label: "Liters", name: "transportation_fuel_liters", value: item.transportation_fuel_liters, rowIndex: index, disabled: false },
                                                { id: 2, label: "Cost per liters", name: "transportation_fuel_cost", value: item.transportation_fuel_cost, rowIndex: index, disabled: false },
                                                { id: 3, label: "Total Cost", name: "total_transportation_fuel_cost", value: item.total_transportation_fuel_cost, rowIndex: index, disabled: true },
                                            ]))
                                        },
                                        {
                                            header: "Fuel used for Other operations",
                                            data: state.form_option_14th_rows.map((item, index) => ([
                                                { id: 1, label: "Liters", name: "operations_fuel_liters", value: item.operations_fuel_liters, rowIndex: index, disabled: false },
                                                { id: 2, label: "Cost per liters", name: "operations_fuel_cost", value: item.operations_fuel_cost, rowIndex: index, disabled: false },
                                                { id: 3, label: "Total Cost", name: "total_operations_fuel_cost", value: item.total_operations_fuel_cost, rowIndex: index, disabled: true },
                                            ]))
                                        },
                                        {
                                            header: "Overall",
                                            data: state.form_option_14th_rows.map((item, index) => ([
                                                { id: 1, label: "Total Liters", name: "overallLiters", value: item.overallLiters, rowIndex: index, disabled: true },
                                                { id: 2, label: "Final Cost", name: "finalCost", value: item.finalCost, rowIndex: index, disabled: true },
                                            ]))
                                        },
                                    ].map((section, i) => (
                                        <React.Fragment key={i}>
                                            {/* Header */}
                                            <Grid item size={{ xs: 12, md: 12 }}>
                                                <Typography variant="h6" sx={{ textAlign: "start", fontWeight: "bold" }}>
                                                    {section.header}
                                                </Typography>
                                            </Grid>

                                            {/* Fields */}
                                            {section.data.map((row) =>
                                                row.map((field) => (
                                                    <Grid key={field.id + "-" + field.rowIndex} item size={{ xs: 12, md: 4 }}>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            label={field.label}
                                                            value={field.value || ""}
                                                            disabled={field.disabled}
                                                            sx={field.disabled ? {
                                                                "& .MuiInputBase-input": {
                                                                    color: "#000",        // value text color
                                                                },
                                                                "& .Mui-disabled .MuiInputBase-input": {
                                                                    WebkitTextFillColor: "#000",   // important for disabled
                                                                },
                                                                // background for disabled
                                                                "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                    backgroundColor: "#e5e5e5",      // change to what you want
                                                                },
                                                                "& .MuiInputLabel-root": {
                                                                    color: "#000",
                                                                    fontWeight: 700, // thick black
                                                                },
                                                            } : {}}
                                                            onChange={(e) => handleAddRowFormChange(field.rowIndex, field.name, "14th", e.target.value.replace(/\D/g, "").slice(0, 50))}
                                                        />
                                                    </Grid>
                                                ))
                                            )}
                                        </React.Fragment>
                                    ))
                                }

                                <Grid item size={{ xs: 12, md: 12 }} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <span style={{ color: "green" }}>Grand Total :</span>&nbsp;<Typography variant="body1" fontStyle="bold">
                                        {state.form_option_14th_rows.map((item) => parseInt(item.finalCost) || 0)}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>


                    {/* Cotton Profit Information */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Cotton Profit Information :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                <Grid item size={{ xs: 12, md: 12 }}>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableBody>
                                                {state.cotton_income_details_arr.map((row) => (
                                                    <TableRow key={row.id}>
                                                        <TableCell>{row.id}.</TableCell>

                                                        <TableCell>{row.label}</TableCell>

                                                        <TableCell>
                                                            <TextField
                                                                type="text"
                                                                size="small"
                                                                placeholder="Enter..."
                                                                value={row.value}
                                                                fullWidth
                                                                // onChange={(e) => {
                                                                //   let inputValue = e.target.value;
                                                                //   // Allow only numbers with up to two decimal places
                                                                //   if (/^\d*\.?\d{0,2}$/.test(inputValue)) {
                                                                //     handle15Change(row.id, inputValue);
                                                                //   }
                                                                // }}
                                                                disabled={row.is_disabled}
                                                                sx={row.is_disabled ? {
                                                                    "& .MuiInputBase-input": {
                                                                        color: "#000",        // value text color
                                                                    },
                                                                    "& .Mui-disabled .MuiInputBase-input": {
                                                                        WebkitTextFillColor: "#000",   // important for disabled
                                                                    },
                                                                    // background for disabled
                                                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                                                        backgroundColor: "#e5e5e5",      // change to what you want
                                                                    },
                                                                    "& .MuiInputLabel-root": {
                                                                        color: "#000",
                                                                        fontWeight: 700, // thick black
                                                                    },
                                                                } : {}}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                    {/* Awareness on Decent Work */}
                    <Box mt={1} width="100%">
                        {/* Header */}
                        <Typography variant="h6" fontWeight="bold" mb={1} mt={2}>
                            Awareness on Decent Work :
                        </Typography>

                        <Paper
                            elevation={3}
                            sx={{
                                border: "1px solid #e0e0e0",
                                p: 2,
                                borderRadius: 2,
                            }}
                        >
                            <Grid container spacing={1}>
                                <Grid item size={{ xs: 12, md: 12 }}>
                                    <TableContainer component={Paper} sx={{
                                        boxShadow: 6,
                                        overflowY: "auto",          // vertical scroll
                                        overflowX: { xs: "auto", md: "hidden" }, // horizontal scroll only on mobile
                                        WebkitOverflowScrolling: "touch", // smooth mobile scroll
                                    }}>
                                        <Table size="small"  >
                                            <TableHead sx={{
                                                backgroundColor: clientTheme.activeBg,
                                            }}>
                                                <TableRow>
                                                    <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>Particulars</TableCell>
                                                    <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>High</TableCell>
                                                    <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>Medium</TableCell>
                                                    <TableCell align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>Low</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {state.awareness_childlabour_details_arr.map((item) => (
                                                    <TableRow key={item.id}>
                                                        <TableCell>{item.name}</TableCell>

                                                        {["High", "Medium", "Low"].map((level) => (
                                                            <TableCell key={level} align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                                                <Radio
                                                                    name={`item-${item.id}`}
                                                                    value={level}
                                                                    checked={item.value === level}
                                                                    onChange={(e) => handleRadioChange(item.id, e.target.value)}
                                                                    sx={{
                                                                        color: "red", // unchecked color
                                                                        "&.Mui-checked": {
                                                                            color: "green", // checked color
                                                                        },
                                                                        "&.Mui-disabled": {
                                                                            color: "red",
                                                                        },
                                                                        "&.Mui-disabled.Mui-checked": {
                                                                            color: "green",
                                                                        },
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>

                </CardContent>
                <CardActions sx={{ justifyContent: "center", mb: 1, mt: 1 }}>
                    <CustomButton
                        status={state.is_loading === true ? "loading" : "idle"}
                        onClick={handleUpdating}
                        label="Create"
                        loadingLabel="Creating.."
                    />
                </CardActions>
            </Card>


            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </Box>
    )
}
export default FieldBookEdit;